import { render, staticRenderFns } from "./TemplateList.vue?vue&type=template&id=bb6c9da6&scoped=true&"
import script from "./TemplateList.vue?vue&type=script&lang=js&"
export * from "./TemplateList.vue?vue&type=script&lang=js&"
import style0 from "./TemplateList.vue?vue&type=style&index=0&id=bb6c9da6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6c9da6",
  null
  
)

export default component.exports